<section class="component-container">
  <div class="page-header">
    <h3 class="page-title">FAQ's</h3>
  </div>

  <div class="custom-tabs">
    @for(t of types; track t) {
    <button class="tab-button" (click)="getFaqs(t)"
      [ngClass]="t === selectedType ? 'active' : ''">{{ t }}</button>
    }
  </div>

  <div class="accordion">
    @for (item of faqs; track item; let i = $index) {
    <div class="accordion-item" (click)="toggleItem(i)">
      <div class="accordion-question">
        {{ item.question }}
        <span class="accordion-icon" [ngClass]="{'rotate': expandedIndex == i}">
          <img src="../../../assets/icons/bottom-arrow.svg" />
        </span>
      </div>
      @if (expandedIndex == i) {
      <div class="accordion-answer">
        {{ item.answer }}
      </div>
      }
    </div>
    }
    </div>
</section>